'use client';

import { forwardRef } from 'react';
import CoreLink, { type PrefetchLinkProps } from '@eliadmin/core/src/components/link/prefetch-link';
import { isEmptyAutodielyNavigation } from '../../../src/autodiely-empty-navigation';

export type { PrefetchLinkProps };

export const Link = forwardRef<HTMLAnchorElement, PrefetchLinkProps>((props, ref) => {
  if (isEmptyAutodielyNavigation(props.href)) return null;
  return <CoreLink {...props} ref={ref} />;
});

Link.displayName = 'AutodielyLink';
export default Link;
